<template>
  <div class="auth">
    <div class="auth-banner">
      <img
        class="auth-banner-image"
        src="../assets/images/auth-patient-banner.jpeg"
        alt="Paciente banner"
      />
    </div>

    <div class="auth-form">
      <RouterLink to="/">
        <img
          class="auth-form-logo"
          src="../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </RouterLink>

      <div class="auth-form-container">
        <h2 class="auth-title auth-form-title">Entre na sua conta</h2>
        <h6 class="auth-subtitle auth-form-subtitle">
          Acesse agora sua conta para agendar consultas, acompanhar agendamentos
          e muito mais.
        </h6>

        <LoginForm />
      </div>

      <p class="auth-text auth-form-account">
        Não tem uma conta?
        <a href="/cadastrar">Crie agora</a>
      </p>

      <AuthFormSocials />
    </div>
  </div>
</template>

<script>
import LoginForm from "../components/LoginForm.vue";
import AuthFormSocials from "../components/AuthFormSocials.vue";

export default {
  name: "LoginView",
  components: {
    LoginForm,
    AuthFormSocials
  }
};
</script>

<style lang="scss" scoped>
.auth-form-logo {
  display: block;
  height: 40px;
  width: auto;
}
</style>
